import { useState } from 'react';
import { motion } from 'framer-motion';
import { fadeUp } from '../../utils/animations';
import { CalculatorControls } from './CalculatorControls';
import { CalculatorResults } from './CalculatorResults';

const HOURS = 160;
const firstVaFee = { 1: 900, 2: 699, 3: 299 };
const addlVaFee = { 1: 699, 2: 299, 3: 299 };

const computeCosts = (vas, year, wage) => {
    const fee = firstVaFee[year] + (vas - 1) * addlVaFee[year];
    const wages = wage * HOURS * vas;
    const total = fee + wages;
    return { fee, wages, total, blended: total / (HOURS * vas) };
};

export function SavingsCalculator() {
    const [vas, setVas] = useState(1);
    const [year, setYear] = useState(1);
    const [wage, setWage] = useState(10);
    const costs = computeCosts(vas, year, wage);
    const savings = computeCosts(vas, 1, wage).total - costs.total;

    return (
        <section className="bg-navy-900 py-20 md:py-24" data-testid="savings-calculator">
            <div className="max-w-4xl mx-auto px-6 lg:px-12">
                <motion.div {...fadeUp} className="mb-10">
                    <h2 className="font-montserrat font-bold text-3xl md:text-4xl text-white tracking-tight">See Your Cost Drop Over Time</h2>
                    <p className="text-gray-300 mt-3">Slide your team size, relationship year, and VA wage to see your exact monthly cost.</p>
                </motion.div>

                <motion.div {...fadeUp} className="bg-white/5 border border-white/10 rounded-sm p-8 md:p-10">
                    <CalculatorControls vas={vas} setVas={setVas} year={year} setYear={setYear} wage={wage} setWage={setWage} />
                    <CalculatorResults costs={costs} savings={savings} vas={vas} year={year} />
                </motion.div>

                <motion.p {...fadeUp} className="text-gray-400 text-xs mt-4 leading-relaxed">
                    Estimate assumes all VAs are hired at the same time and work 160 hours per month. In practice, each additional VA follows their own independent timeline from their hire date. VA wages are paid directly to your VA.
                </motion.p>
            </div>
        </section>
    );
}
